import * as actions from '../actions/itemActions';

const initialState =  {
  item: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_ITEM:
      return {
        ...state,
        item: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/itemReducer.js